<template>
	<div class="tree-menu-page">
        <transition name="WTF" @after-leave="hiddenTree">
            <div class="WTF"  v-show="callTreeMenu">
                <div class="tree-menu-wrapper" id="tree-menu-wrapper">
                    <transition name="tag-list">
                        <div class="tag-list-wrapper tag-list-wrapper-fixed" v-if="showTagList">
                            <div class="tag-list">
								<span class="tag" @click="getMenuData(tag,index)" :class="{'active-tag':tag.Selected  && tagIndex == index}" v-for="(tag, index) in tagsList" :key="index">
									<i v-text="tag.Name"></i>
								</span>
							</div>
                        </div>
                    </transition>
                    <transition name="tag-title">
                        <div class="tag-title-wrapper tag-title-wrapper-fixed" @click="showTagList = true" v-if="!showTagList && showTagTitle">
                            <span class="tag-title" v-text="tagsList[tagIndex].Name"></span><span class="icon-triangle-active"></span>
                        </div>
                    </transition>
                    <div class="menu-wrapper">
                        <div class="tag-list-wrapper" id="tag-list-wrapper">
                            <div class="tag-list">
								<span class="tag" @click="getMenuData(tag,index)" :class="{'active-tag':tag.Selected  && tagIndex == index}" v-for="(tag, index) in tagsList" :key="index">
									<i v-text="tag.Name"></i>
								</span>
							</div>
                        </div>
                        <div class="collapse-wrapper">
							<transition name="upDown">
								<menu-folder v-if="menuData.length > 0 && ajaxDone" :LogId="LogId" :menuData="menuData" :colIndex="0"></menu-folder>
							</transition>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <div class="tree-menu-mask" @click.prevent="closeTreeMenu"></div>
	</div>
</template>

<script>
	import menuFolder from './menuFolder'
	import store from '../../store/index'
    import {
        HOME,COMMON
    } from '../../api'
    export default {
        name: "treeMenu",
		data(){
			return {
			    LogId:'',
                callTreeMenu:false,
				showTagList:false,
				showTagTitle:false,
				tagsList:null,
				tagIndex:0,
				ajaxDone:false,
			}
		},
		components:{
			menuFolder
		},
		mounted() {
			store.commit('SET_CurrentNode',this.$route.params.uuid.split('&')[0])
			this.getMenuData()
		},
        computed: {
            KICACHE () {
                return this.$store.getters.GET_KI_CACHE
            }
        },
		destroy() {
			document.getElementById('tree-menu-wrapper').removeEventListener(
				"scroll",
				() => {
					this.scrollHandler();
				},
				false
			);
		},
		methods: {
			scrollHandler(){
				let scrollH = document.getElementById('tree-menu-wrapper').scrollTop
				let tagH = document.getElementById('tag-list-wrapper').offsetHeight
				this.showTagList = false;
				this.showTagTitle = !!(scrollH > tagH )
			},
			getMenuData(tag,index){
				let data = null;
				this.ajaxDone = false
				if(tag){
					// 这里不能清空高亮
                    // store.commit('SET_CurrentNode','')
					data = {
						NodeId: tag.NodeId
					}
				}else{
					data= {
						KBInfoId: store.state.menu.KBInfoId
					}
				}
				HOME.GetNodeListMap(data).then(res=>{
					this.tagsList = res.Data.ParentList
					this.tagsList.map((e,i)=>{
						if(e.Selected) {
                            this.getLogId(e)
							if(tag) {
								this.tagIndex = i
								this.ajaxDone = true
							}else{
								setTimeout(() => {
									this.tagIndex = i
									this.ajaxDone = true
								}, 500);
							}
						}
					})
                    store.state.menu.menuList = res.Data.ChildList;
					this.callTreeMenu = true;
					document.getElementById('tree-menu-wrapper').addEventListener(
						"scroll",
						() => {
							this.scrollHandler();
						},
						false
					);
				})
			},

            //获取logid  埋点方法
            getLogId(node){
                try{
                    let data = {
                        Origin:'Detail',
                        NodeId:node.NodeId,
                        NodeName:node.Name
                    }
                    COMMON.AddNodeViewData(data).then((res)=>{
                        this.LogId = res.Data.LogId
                    })
                }
                catch (e) {
                    console.log(e);
                }
            },

            closeTreeMenu(){
                this.callTreeMenu = false;
            },
            hiddenTree(){
				store.state.menu.showMenu = false;
				document.querySelector("#app").style.overflow = "";
            }
		},
        computed:{
			menuData(){
				return store.state.menu.menuList
			}
        }
    }
</script>

<style lang="scss" scoped>
@keyframes showUpSlowly {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}
.tree-menu-page{
	display: flex;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, .3);
    z-index: 1200;
    .WTF{
        width: j(600);
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    .tree-menu-mask{
        flex: 1;
    }
	.tree-menu-wrapper {
        width: 100%;
        height: 100%;
		background-color: #fff;
        overflow-y: scroll;
		.tag-list-wrapper{
			width: 100%;
			padding:j(30) j(50) 0;
			box-sizing: border-box;
			border-bottom: 1px solid #F0F1F2;
			background-color: #fff;
			.tag-list{
				display: flex;
				flex-wrap: wrap;
				margin: 0 j(-35);
				.tag{
					margin: 0 j(35) j(30);
					position: relative;
					max-width: j(280);
					i{
						transition: all .3s linear;
						display: block;
						font-style: normal;
						height:j(40);
						line-height:j(40);
						color:rgba(51,51,51,1);
						font-size:j(28);
						font-weight:400;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space:nowrap;
					}
				}
				.active-tag{
					i{
						color: #00bebe;
						&::after{
							content:'';
							display: block;
							position: absolute;
							top: j(-7);
							bottom: j(-5);
							left: j(-20);
							right: j(-20);
							border: 1px solid #00bebe;
							border-radius: j(25);
							animation: showUpSlowly .4s linear;
						}
					}
				}
			}
		}
		.tag-list-wrapper-fixed{
			position: fixed;
			top: 0;
			left: 0;
			width: j(600);
			z-index: 1;
			overflow: hidden;
		}
		.tag-title-wrapper-fixed{
			position: fixed;
            width: unset;
			top: 0;
			left: 0;
			width: j(600);
			z-index: 1;
			background-color: #fff;
			height: j(80);
			box-shadow:0px j(6) j(4) 0px rgba(147,122,122,0.1);
			display: flex;
			align-items: center;
			justify-content: center;
			.tag-title{
				font-size: j(28);
				color:rgba(0,188,188,1);
				max-width: j(400);
				overflow: hidden;
				text-overflow:ellipsis;
				white-space:nowrap
			}
			.icon-triangle-active{
				height: j(8);
				width: j(14);
				background-image: url('../../../static/images/arrow_up.png');
				background-repeat: no-repeat;
				background-size: contain;
				background-position: center;
				transform: rotateX(180deg);
				margin-left: j(10);
			}
		}
		.menu-wrapper{
            width: 100%;
            box-sizing: border-box;
			.collapse-wrapper{
				padding: j(20) j(50) 0 0;
				overflow: hidden;
			}
		}
	}
}


.tag-list-enter-active,.tag-list-leave-active{
	transition: all .2s linear;
}
.tag-list-enter,.tag-list-leave-to{
	transform: translateY(-100%);
	opacity: 0;
}

.tag-title-enter-active,.tag-title-leave-active{
	transition: all .2s linear;
}
.tag-title-enter,.tag-title-leave-to{
	opacity: 0;
}

.WTF-enter-active,.WTF-leave-active{
	transition: all .1s linear;
}
.WTF-enter,.WTF-leave-to{
    transform: translateX(-100%);
}


.upDown-enter-active{
	transition: all .5s ease;
}
.upDown-leave-active{
	transition: all .1s linear;
}
.upDown-enter{
	opacity: 0;
	transform: translateY(-200px);
}
.upDown-leave-to{
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/treeMenu/treeMenu2.vue